<template>
  <div id="main">
    <div style="position: fixed; width: 1000px; height: 600px; margin: 0px; top: -10px;">
        <canvas id="canvas" width="1000" height="600"></canvas>
    </div>
    <div id="rays_holder">
        <img src="../static/img/logo_bg2x.png" style="height: 200px; z-index: 999; position: relative; opacity: 0.8;" id="logo"/>
        <div id="rays"></div>
    </div>
    <img src="../static/img/hpl.gif" style="border: 3px solid #c3ae8d; margin: 10px; z-index: 999; position: relative; opacity: 0.9;"/>
    <div class="blood_text" style="font-size: 20px; width: 600px; margin: auto;">HOWARD PHILLIPS LOVECAR is an exploration shooter with giant lovecraftian monsters – in a car!</div>
    <div class="blood_text" style="font-size: 20px; margin-bottom: 10px;">Like ENTER THE GUNGEON combined with the classic GTA1/2!</div>

    <div id="tentacles" style="position: fixed; top: 0px;">
        <!--<Tentacle v-for="(t, index) in this.tentacleData" :key="index" :length="t.length" :tentacleId="t.id" :angle="t.angle" :x="t.x" :y="t.y"/>-->
    </div>

    <iframe src="http://store.steampowered.com/widget/644370/" frameborder="0" width="646" height="190"></iframe>
    <!--
    <form method="post" action="https://app.freshmail.com/en/actions/subscribe/" id="mail_signup">
      <input type="hidden" name="subscribers_list_hash" value="y6qvj3r823" />
      <label for="freshmail_email" class="blood_text_" style="font-size: 16px;">Sign up for more info! No spam.</label><br /><br />
      <input type="text" id="freshmail_email" name="freshmail_email" placeholder="Your e-mail address..." class="email"/> <input type="submit" class="button" value="Subscribe" /><br />
    </form>
    -->
    <br/>
    <div style="width: 600px; margin: auto; text-align: center;">
        <div style="margin: auto; font-size: 20px;" class="blood_text">PLANNED FEATURES:</div>
        <ul style="text-align: left;">
            <li>randomized to provide replayability</li>
            <li>lots of guns and enemies</li>
            <li>huge Cthulhu-inspired monsters available for dismembering</li>
            <li>focused on fun instead of grind/frustration</li>
        </ul>
    </div>
    <div>
        Made by <a href="http://twitter.com/thotep">Przemek Müller</a>. Here's the <a href="http://thesecretpie-presskit.appspot.com/sheet.php?p=HPL">press kit</a>.
    </div>

    <div style="display: none;">
        <img src="../static/img/rtentacle_00.png" id="tentacle_00"/>
        <img src="../static/img/rtentacle_01.png" id="tentacle_01"/>
        <img src="../static/img/rtentacle_02.png" id="tentacle_02"/>
        <img src="../static/img/rtentacle_03.png" id="tentacle_03"/>
        <img src="../static/img/rtentacle_04.png" id="tentacle_04"/>
        <img src="../static/img/rtentacle_05.png" id="tentacle_05"/>
        <img src="../static/img/rtentacle_06.png" id="tentacle_06"/>
        <img src="../static/img/rtentacle_07.png" id="tentacle_07"/>
        <img src="../static/img/rtentacle_08.png" id="tentacle_08"/>
        <img src="../static/img/rtentacle_09.png" id="tentacle_09"/>
    </div>
  </div>
</template>

<script>
import Tentacle from './components/Tentacle'
import TWEEN from '@tweenjs/tween.js'
import M from 'transformation-matrix-js'

export default {
  name: 'App',
  components: {
    Tentacle
  },
  data () {
    let tentacleData = []
    let tentacleCount = 9
    let fr = 600 / tentacleCount
    for (var i = 0; i < tentacleCount; i++) {
      // let left = Math.random() > 0.5
      // let t = {id: i + 1, length: this.randomInt(4, 9), angle: left ? 90 : 270, x: left ? 0 : 1000, y: Math.random() * 100 + 50}
      // let t = {id: i + 1, length: this.randomInt(4, 9), angle: 0, x: Math.random() * 500, y: 500}
      let t = {id: i + 1, length: this.randomInt(4, 9), angle: 180, x: 200 + fr * (i + 0) + fr * 0.5 * (Math.random() - 0.5), y: -75}
      tentacleData.push(t)
    }
    return {
      tentacleData: tentacleData,
      tentacles: [],
      ctx: null,
      canvas: null
    }
  },
  mounted () {
    this.canvas = document.getElementById('canvas')
    this.ctx = this.canvas.getContext('2d')
    for (var i = 0; i < this.tentacleData.length; i++) {
      this.createTentacle(i)
    }
    this.canvas.interval = setInterval(this.updateCanvas, 20)
    this.ctx.globalCompositeOperation = 'destination-over'
  },
  methods: {
    randomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    createTentacle (ind) {
      let data = this.tentacleData[ind]
      let tent = {
        x: data.x,
        y: data.y,
        parts: []
      }
      for (var i = 0; i < data.length; i++) {
        let imgId = 'tentacle_0' + (10 - data.length + i)
        let part = {
          id: i,
          matrix: new M.Matrix(),
          parentMatrix: new M.Matrix(),
          // angle: i === 0 ? data.angle : 0,
          angle: 0,
          tween: null,
          image: document.getElementById(imgId),
          imageId: imgId
        }
        let toRot = (Math.random() - 0.5) * 20 * (i + 1)
        part.tween = new TWEEN.Tween({rotation: part.angle})
          .to({rotation: toRot}, Math.random() * 1500 + 1000)
          .repeat(Infinity)
          .yoyo(true)
          .easing(TWEEN.Easing.Sinusoidal.InOut)
          .onUpdate(function (params) {
            let delta = params.rotation - part.angle
            part.angle += delta
          })
        part.tween.start()
        tent.parts.push(part)
      }
      this.tentacles.push(tent)
    },
    updateCanvas () {
      TWEEN.update()
      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.fillStyle = 'red'
      for (var i = 0; i < this.tentacles.length; i++) {
        this.ctx.setTransform(1, 0, 0, 1, 0, 0)
        let tent = this.tentacles[i]
        this.ctx.translate(tent.x, tent.y)
        for (var j = 0; j < tent.parts.length; j++) {
          let tpart = tent.parts[j]
          let angle = tpart.angle
          this.ctx.rotate(angle * Math.PI / 180)
          this.ctx.drawImage(tpart.image, -50, 0, 100, 64)
          this.ctx.translate(0, 54)
        }
      }
    }
  }
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Arbutus+Slab');
    @import url('https://fonts.googleapis.com/css?family=Alice');

    body {
        background-color: #352f26;
        color: #c3ae8d;
        font-family: 'Arbutus Slab', serif;
    }

    #main {
        width: 1000px;
        margin: auto;
        text-align: center;
    }

    #canvas {
        width: 1000px;
        height: 600px;
    }

    a {
        color: #c3ae8d;
        background-color: #534a3c;
        padding: 4px;
    }

    div.logos {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    /* keyframes for animation;  simple 0 to 360 */
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    @keyframes heartbeat
    {
      0%
      {
        transform: scale( .97 );
      }
      16%
      {
        transform: scale( 1 );
      }
      32%
      {
        transform: scale( .97 );
      }
      48%
      {
        transform: scale( 1 );
      }
      64%
      {
        transform: scale( .97 );
      }
      100%
      {
        transform: scale( .97 );
      }
    }

    #rays_holder    {
        position: relative;
    }
    #logo {
        animation: heartbeat 1s infinite;
    }
    #rays   { /* with animation properties */
        background: url(../static/img/rays.png) 0 0 no-repeat;
        position: absolute;
        top: -140px;
        left: 243px;
        width: 490px;
        height: 490px;
        z-index: -1;

        /* microsoft ie */
        animation-name: spin;
        animation-duration: 110s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    .blood_text {
    text-shadow:
      -1px -1px 0 #982626,
      1px -1px 0 #982626,
       -1px 1px 0 #982626,
       1px 1px 0 #982626;
    }

    #mail_signup {
        border: 3px solid #c3ae8d;
        margin: auto;
        width: 400px;
        padding: 20px;
    }

    #mail_signup input.email {
        font-size: 15px;
        font-family: 'Arbutus Slab', serif;
        border: 1px solid #ABB0B2;
        border-radius: 3px;
        color: #343434;
        background-color: #fff;
        box-sizing:border-box;
        height:28px; padding: 0px 0.4em; display: inline-block; margin: 0; width:200px; vertical-align:top;
    }

    #mail_signup .button {
        font-size: 14px;
        color: #c3ae8d;
        font-family: 'Arbutus Slab', serif;
        border: none;
        border-radius: 3px;
        letter-spacing: .03em;
        background-color: #982626;
        box-sizing:border-box; height:28px; line-height:28px; padding:0 18px; display: inline-block; margin: 0; transition: all 0.23s ease-in-out 0s;
    }

    #mail_signup .button:hover {background-color:#534a3c; cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/App.vue